<template>
  <transition name="fade" appear>
    <div class="cookie fixed w-100 bg-cl-th-accent cl-tertiary" v-if="isOpen">
      <div class="px20">
        <div class="row coockie-style between-xs middle-xs px15">
          <div class="col-xs-10 start-xs">
            <cms-block-chunk
              class="cookie_popup"
              :identifier="`c_COOKIES_POPUP`"
            />
          </div>
          <div class="col-xs-2 end-xs">
            <span
              @click="accept"
              @keyup.enter="accept"
              tabindex="0"
              role="button"
            >
              <cms-block-chunk
                class="cookie_popup-button"
                :identifier="`c_COOKIES_POPUP_BUTTON`"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import i18n from "@vue-storefront/i18n";
import CmsBlockChunk from "theme/components/core/blocks/Cms/BlockChunk";
export default {
  props: {
    detailsLinkText: {
      type: String,
      default: i18n.t("See details"),
    },
    detailsLink: {
      type: String,
      default: "/i/polityka-plikow-cookies",
    },
    message: {
      type: String,
      default: i18n.t(
        "We use cookies to give you the best shopping experience."
      ),
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  components: {
    CmsBlockChunk,
  },
  methods: {
    accept() {
      this.setVisited();
      this.isOpen = false;
    },
    setVisited() {
      this.$store.dispatch("claims/set", {
        claimCode: "cookiesAccepted",
        value: true,
      });
      this.$store.dispatch("uiStore/setBottom", { bottom: "40px" });
    },
  },
  mounted() {
    this.$store
      .dispatch("claims/check", { claimCode: "cookiesAccepted" })
      .then((cookieClaim) => {
        if (!cookieClaim) {
          this.isOpen = true;
          this.$store.dispatch("claims/set", {
            claimCode: "cookiesAccepted",
            value: false,
          });
          this.$store.dispatch("uiStore/setBottom", { bottom: "100px" });
        } else {
          this.isOpen = !cookieClaim.value;
          if (!this.isOpen) {
            this.$store.dispatch("uiStore/setBottom", { bottom: "40px" });
          }
        }
      });
  },
};
</script>

<style lang="scss" scoped>
@import "~theme/css/base/global_vars";
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$color-icon: color(black);
$bg-icon: color(suva-gray);
$z-index: 22 + map-get($z-index, overlay);

.cookie {
  z-index: $z-index;
  bottom: 0;
  padding: 25px 0;
}

.cookie_popup {
  color: #fff !important;
}

.cookie_popup-button {
  color: #fff !important;
  cursor: pointer;
}

.icon:hover {
  color: $color-icon;
  background-color: $bg-icon;
}
@media (max-width: 767px) {
  .coockie-style {
    flex-direction: column;
    & > div {
      max-width: 100%;
      text-align: center;
    }
  }
  .cookie_popup-button {
    border: 1px solid white;
    border-radius: 25px;
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 10px;
  }
}
.cookie.fixed.w-100.bg-cl-th-accent.cl-tertiary > div > div {
  max-width: 100% !important;
}
</style>
